export default {
  labels: {
    order: 'Commande',
    customer: 'Client',
  },
  tags: {
    new_customer: 'Nouveau client',
    loyal_customer: 'Client fidèle',
  },
};
